<template>
  <div class="gametitle" :class="game">
    <div>
      <h2>{{ gamemap[game].title }}</h2>
    </div>
    <div @click="help" class="ion-activatable helpbtn">
      <div>Hướng dẫn</div>
      <ion-icon size="large" :icon="helpCircle"></ion-icon>
      <ion-ripple-effect></ion-ripple-effect>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gametitle {
  color: #fff;
  margin: 0;
  padding: 0 3vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .helpbtn {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 1vw 3vw;
  }
  &.keno {
    background-color: #fac952;
    border-bottom: 2px solid #deb248;
  }
  &.max3d {
    background-color: #db8bda;
    border-bottom: 2px solid #c27bc1;
  }
  &.max4d,
  &.max3dpro {
    background-color: #ff34d7;
    border-bottom: 2px solid #e22ebf;
  }
  &.mega {
    background-color: #ff562f;
    border-bottom: 2px solid #e24c29;
  }
  &.power {
    background-color: #ff992f;
    border-bottom: 2px solid #e28829;
  }
  &.xskt {
    background-color: #6164ff;
    border-bottom: 2px solid #4042aa;
  }

  h2 {
    margin: 16px 10px;
    font-weight: bold;
  }
}
</style>

<script>
import { defineComponent } from "vue";
import { IonIcon, IonRippleEffect } from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "GameTitle",
  props: ["game"],
  components: {
    IonIcon,
    IonRippleEffect,
  },
  methods: {
    help() {
      this.router.push("/info/help/" + this.game);
    },
  },
  setup() {
    const router = useRouter();
    const gamemap = {
      keno: { title: "Keno" },
      max3d: { title: "Max3D" },
      max4d: { title: "Max4D" },
      max3dpro: { title: "Max3D Pro" },
      mega: { title: "Mega" },
      power: { title: "Power" },
      xskt: { title: "Xổ số kiến thiết" },
    };
    return {
      router,
      gamemap,
      helpCircle,
    };
  },
});
</script>
